if(window.JET_PDP_INIT){console.warn('jet-pdp: already initialised');}else{window.JET_PDP_INIT=1;


document.documentElement.classList.add('js');
var slides=[].slice.call(document.querySelectorAll('.slide'));
var thumbs=[].slice.call(document.querySelectorAll('.thumb'));
var cur=0;
function set(i){cur=(i+slides.length)%slides.length;slides.forEach(function(s,n){s.classList.toggle('active',n===cur)});thumbs.forEach(function(t,n){t.classList.toggle('active',n===cur)});}
function go(d){set(cur+d);}

var sizePrice=1149, sizeName='Full Body', sizeDim='72" x 24"', sizePower=88, sizeDesc='Most-chosen size. Full back, hips and legs covered while you lie down.';
var qty=1;
var shopifySize='Jet Mat 72" x 24"';
var volt='110V';
var QTY_RATE={1:0,2:0.02,3:0.03,4:0.05};
var SPEC_BY_SIZE={
  'Compact':{dim:'20 x 20 x 1 in',w:'7 lbs',p:'45 W',g:'8 Gauss',coils:'2',photons:'36'},
  'Chair / Desk':{dim:'40 x 18 x 1.2 in',w:'10 lbs',p:'90 W',g:'8 Gauss',coils:'2',photons:'60'},
  'Medium':{dim:'40 x 24 x 1.2 in',w:'15 lbs',p:'130 W',g:'8 Gauss',coils:'4',photons:'60'},
  'Mid-Length':{dim:'60 x 24 x 1.2 in',w:'21 lbs',p:'210 W',g:'8 Gauss',coils:'6',photons:'108'},
  'Full Body':{dim:'72 x 24 x 1.2 in',w:'26 lbs',p:'220 W',g:'8 Gauss',coils:'6',photons:'132'},
  'Grand':{dim:'74 x 28 x 1.2 in',w:'31 lbs',p:'260 W',g:'12 Gauss',coils:'8',photons:'144'}
};
var extras={pillow:0,lifetime:0};
function money(n){return '$'+n.toLocaleString('en-US',{maximumFractionDigits:0});}
var GIFT_TOTAL=227;
function setDisplay(id,show){var el=document.getElementById(id);if(el){el.style.display=show?'':'none';}}
function recompute(){
  var rate = QTY_RATE[qty] || 0;
  var matSubtotal = Math.round(sizePrice * qty * (1 - rate));
  var ex=0; for(var ek in extras){ ex+=extras[ek]||0; }
  var orderTotal = matSubtotal + ex;
  var saved = Math.round(sizePrice * qty * rate);
  var giftsOn = true;            // gifts included with every mat (client confirmed Jul 24)
  var GV = giftsOn ? GIFT_TOTAL : 0;
  var value = sizePrice * qty + GV;           // struck "value"
  document.getElementById('ledgerPrice').textContent=money(matSubtotal);
  var _lw=document.getElementById('ledgerWas'); if(_lw){ if(value>matSubtotal){_lw.textContent=money(value);_lw.style.display='';} else {_lw.style.display='none';} }
  document.getElementById('ledgerName').textContent=sizeName+(qty>1?' · '+qty+'-pack':'');
  document.getElementById('ledgerDim').textContent=sizeDim;
  document.getElementById('ctaPrice').textContent=money(orderTotal);
  document.getElementById('sbPrice').textContent=money(orderTotal);
  document.getElementById('sbSize').textContent=sizeName+(qty>1?' ('+qty+'-pack)':'');
  var _mo=resolveMatObj(); var _sb=document.getElementById('stockBadge'); var _in=!_mo||_mo.avail!==false;
  if(_sb){ _sb.innerHTML=_in?'<svg class="icon" style="width:13px;height:13px"><use href="#i-check"/></svg> In stock':'Out of stock'; _sb.style.color=_in?'var(--sage)':'#c73c22'; }
  document.querySelectorAll('button[onclick="addToCart()"]').forEach(function(b){ b.disabled=!_in; b.style.opacity=_in?'':'0.5'; });
  var _pv=document.getElementById('jetPayVariant'); if(_pv&&_mo&&String(_pv.value)!=String(_mo.id)){_pv.value=_mo.id;_pv.dispatchEvent(new Event('change',{bubbles:true}));}
  document.getElementById('powerFill').style.width=sizePower+'%';
  document.getElementById('sizeDesc').textContent=sizeDesc;
  // quantity "you save" line
  var qs=document.getElementById('qtySaved');
  if(qs){ qs.classList.toggle('show',qty>1); var qsa=document.getElementById('qtySavedAmt'); if(qsa) qsa.textContent=money(saved); }
  // gift gating: free gift set only on Full Body ($1,149) and Grand ($1,649)
  setDisplay('ledgerGiftPill',giftsOn);
  setDisplay('giftBand',giftsOn);
  setDisplay('giftCard',giftsOn);
  setDisplay('giftCardNote',!giftsOn);
  var sbGifts=document.getElementById('sbGifts'); if(sbGifts){sbGifts.style.display=giftsOn?'':'none';}
  // full per-size spec list in the buy-box Specifications dropdown (real HealthyLine data)
  var sl=document.getElementById('specList');
  if(sl){ var sp=SPEC_BY_SIZE[sizeName];
    if(sp){
      var rows=[['Dimensions',sp.dim],['Weight','Approx. '+sp.w],['Power',sp.p],['Heat','Up to 158°F (70°C)'],['Far-infrared wavelength','8 to 10 µm'],['PEMF peak intensity',sp.g],['PEMF coils',sp.coils],['PEMF frequencies','0.25 to 30 Hz (default 7.83 Hz, shown as 8 Hz)'],['PEMF waveform','Sine'],['PEMF cycle','20 min on / 100 min off, repeating until shut-off'],['Red-light photons',sp.photons+' at 630 nm'],['Power input','110V (US)']];
      var hh=''; for(var r=0;r<rows.length;r++){ hh+='<li><b>'+rows[r][0]+':</b> '+rows[r][1]+'</li>'; }
      sl.innerHTML=hh;
      var pit=sl.closest('.spec-item'); if(pit&&pit.classList.contains('open')){ var pa=pit.querySelector('.spec-a'); if(pa) pa.style.maxHeight=pa.scrollHeight+'px'; }
    }
  }
  var n=qty; for(var k in extras){if(extras[k])n++;} var _cn=document.getElementById('cartN'); if(_cn)_cn.textContent=n;
  // grand upsell nudge: show only when a non-Grand size is selected
  var gn=document.getElementById('grandNudge'); if(gn){gn.classList.toggle('show',sizeName!=='Grand');}
}
function selectGrand(){
  var match=null;
  document.querySelectorAll('.size').forEach(function(b){ if(b.dataset.name==='Grand') match=b; });
  if(match){ match.click(); }
}
function pickQty(el){
  qty=parseInt(el.dataset.qty,10)||1;
  document.querySelectorAll('#qtyRow .qty-opt').forEach(function(b){b.classList.remove('on')});
  el.classList.add('on');
  recompute();
}
function toggleFit(){var f=document.getElementById('fitFind');var open=f.classList.toggle('open');f.querySelector('.fitfind-head').setAttribute('aria-expanded',open?'true':'false');}
function pickFit(el){
  document.querySelectorAll('#fitOpts .fit-opt').forEach(function(b){b.classList.remove('on')});
  el.classList.add('on');
  var rec=el.dataset.rec;
  var match=null;
  document.querySelectorAll('.size').forEach(function(b){ if(b.dataset.name===rec) match=b; });
  if(match){ match.click(); }
  var box=document.getElementById('fitRec');
  document.getElementById('fitRecName').textContent=rec;
  box.classList.add('show');
}
document.querySelectorAll('.size').forEach(function(btn){
  btn.addEventListener('click',function(){
    document.querySelectorAll('.size').forEach(function(b){b.classList.remove('active')});
    btn.classList.add('active');
    sizePrice=parseInt(btn.dataset.price,10);
    sizeName=btn.dataset.name;
    sizeDim=btn.dataset.dim;
    sizePower=parseInt(btn.dataset.power,10)||60;
    sizeDesc=btn.dataset.desc||'';
    if(btn.dataset.size){shopifySize=btn.dataset.size;} updateSizeImage();
    recompute();
  });
});
function toggleAdd(el){
  var key=el.dataset.key, p=parseInt(el.dataset.price,10);
  if(extras[key]){extras[key]=0;el.classList.remove('on');}
  else{extras[key]=p;el.classList.add('on');}
  recompute();
}
function matLineQty(){
  var rate=QTY_RATE[qty]||0;
  var sub=Math.round(sizePrice*qty*(1-rate));
  return sizeName+' Jet InfraMat Pro x'+qty+(qty>1?' ('+Math.round(rate*100)+'% off, '+money(sub)+')':' ('+money(sub)+')');
}
function resolveMatObj(){
  var byV=(window.JET_MAP&&window.JET_MAP[shopifySize])||null;
  if(byV&&byV[volt]) return byV[volt];
  if(byV&&byV['110V']) return byV['110V'];
  return null;
}
function resolveMatVariant(){ var o=resolveMatObj(); return o?o.id:null; }
function planVariantForSize(){
  if(!window.JET_PLAN) return null;
  var nums=(sizeDim.match(/\d+/g)||[]);
  for(var i=0;i<window.JET_PLAN.length;i++){var t=window.JET_PLAN[i].title;var ok=nums.length>0;for(var j=0;j<nums.length;j++){if(t.indexOf(nums[j])<0)ok=false;}if(ok)return window.JET_PLAN[i].id;}
  return null;
}
function pillowVariantForVolt(){
  if(!window.JET_PILLOW) return null;
  for(var i=0;i<window.JET_PILLOW.length;i++){if(window.JET_PILLOW[i].title.indexOf(volt)>-1)return window.JET_PILLOW[i].id;}
  return window.JET_PILLOW.length?window.JET_PILLOW[0].id:null;
}
function addToCart(){
  var mat=resolveMatVariant();
  if(!mat){window.location.href='/products/'+window.JET_HANDLE;return;}
  var items=[{id:mat,quantity:qty}];
  if(extras.pillow){var pv=pillowVariantForVolt(); if(pv)items.push({id:pv,quantity:1});}
  if(extras.lifetime){var pl=planVariantForSize(); if(pl)items.push({id:pl,quantity:1});}
  var btns=document.querySelectorAll('button[onclick="addToCart()"]');
  btns.forEach(function(b){b.disabled=true;});
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
    .then(function(r){return r.json();})
    .then(function(){if(extras.pillow){return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:'JETBUNDLE50'})}).catch(function(){});}}).then(function(){window.location.href=extras.pillow?'/discount/JETBUNDLE50?redirect=%2Fcart':'/cart';})
    .catch(function(){window.location.href='/cart';});
}
function showGem(key,el){
 var root=el.closest('.jet-sec')||document;
 root.querySelectorAll('.gem-tab').forEach(function(t){t.classList.remove('on')}); el.classList.add('on');
 root.querySelectorAll('.gem-pane').forEach(function(p){p.classList.toggle('on',p.getAttribute('data-gem')===key)});
 root.querySelectorAll('.gem-img').forEach(function(i){i.classList.toggle('on',i.getAttribute('data-gem')===key)});
}
function showTx(key,el){
 var root=el.closest('.jet-sec')||document;
 root.querySelectorAll('.thx-tab').forEach(function(b){b.classList.remove('on')}); el.classList.add('on');
 root.querySelectorAll('.thx-panel').forEach(function(p){p.classList.toggle('on',p.getAttribute('data-tx')===key)});
}
function tQ(b){var q=b.parentElement;var open=q.classList.contains('open');document.querySelectorAll('.q').forEach(function(x){x.classList.remove('open');x.querySelector('.q-a').style.maxHeight=null;});if(!open){q.classList.add('open');var a=q.querySelector('.q-a');a.style.maxHeight=a.scrollHeight+'px';}}
function tSpec(b){var it=b.parentElement;var a=it.querySelector('.spec-a');var isOpen=it.classList.contains('open');if(isOpen){it.classList.remove('open');a.style.maxHeight=null;}else{it.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}}
// open the first spec panel on load
(function(){var o=document.querySelector('.spec-item.open .spec-a');if(o){o.style.maxHeight=o.scrollHeight+'px';}})();
var buy=document.getElementById('buy'), bar=document.getElementById('stickybar');
window.addEventListener('scroll',function(){ var b=buy.getBoundingClientRect(); if(b.bottom<140) bar.classList.add('show'); else bar.classList.remove('show'); });
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{threshold:.1});
document.querySelectorAll('.fadeup').forEach(function(el){io.observe(el)});
document.querySelectorAll('.wave').forEach(function(w){var n=+w.dataset.bars||12,h='';for(var i=0;i<n;i++){var ht=8+Math.round(26*Math.abs(Math.sin(i*0.8+1)));h+='<i style="height:'+ht+'px"></i>';}w.innerHTML=h;});
// trust marquee: build items, duplicate the set so translateX(-50%) loops seamlessly
var MARQ=['5 therapies in one device','21 functional layers','90 nights to fall in love','630 nm red light','PEMF up to 12 Gauss','Far infrared up to 158°F','500,000+ clients served','US-patented PEMF + heat','HSA / FSA eligible'];
(function(){var t=document.getElementById('marqTrack');if(!t)return;var one='';for(var i=0;i<MARQ.length;i++){one+='<span class="marquee-item">'+MARQ[i]+'</span><span class="marquee-dot"></span>';}t.innerHTML=one+one;})();
(function(){var its=document.querySelectorAll('.announce .a-item');if(its.length<2)return;var i=0;its[0].classList.add('on');function nx(){its[i].classList.remove('on');i=(i+1)%its.length;its[i].classList.add('on');}var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;var t=reduce?null:setInterval(nx,3000);var bar=document.querySelector('.announce');if(bar){bar.addEventListener('mouseenter',function(){if(t){clearInterval(t);t=null;}});bar.addEventListener('mouseleave',function(){if(!t&&!reduce){t=setInterval(nx,3000);}});}})();
document.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){var el=e.target;if(el&&el.classList&&el.classList.contains('tile-vid')){e.preventDefault();playReel(el);}}});
recompute();
function pickVolt(el){el.parentElement.querySelectorAll(".volt-opt").forEach(function(b){b.classList.remove("on")});el.classList.add("on");volt=el.dataset.v==="220"?"220V":"110V";recompute();}
function playReel(el){var v=el.querySelector("video");if(!v)return;if(v.paused){document.querySelectorAll(".tile-vid video").forEach(function(o){if(o!==v){o.pause();if(o.parentElement)o.parentElement.classList.remove("playing");}});v.muted=false;el.classList.add("playing");var pr=v.play();if(pr&&pr.catch){pr.catch(function(){v.muted=true;v.play();});}}else{v.pause();el.classList.remove("playing");}}

var SIZE_IMG={"Jet Mat 20\" x 20\"":"https://cdn.shopify.com/s/files/1/0639/6172/7028/files/Amethyst-Tourmaline-Jade-Obsidian-Quartz-Jet-Mat_-2020-Firm-Photon-PEMF-InfraMat-Pro_1.webp?v=1757967617","Jet Mat 40\" x 24\"":"https://cdn.shopify.com/s/files/1/0639/6172/7028/files/Amethyst-Tourmaline-Jade-Obsidian-Quartz-Jet-Mat_-4024-Firm-Photon-PEMF-InfraMat-Pro_1.webp?v=1775058298","Jet Chair 40\" x 18\"":"https://cdn.shopify.com/s/files/1/0639/6172/7028/files/Amethyst-Tourmaline-Jade-Obsidian-Quartz-Jet-Chair-4018-Firm-Photon-PEMF-InfraMat-Pro_1.jpg?v=1775058298","Jet Mat 60\" x 24\"":"https://cdn.shopify.com/s/files/1/0639/6172/7028/files/Amethyst-Tourmaline-Jade-Obsidian-Quartz-Jet-Mat_-6024-Firm-Photon-PEMF-InfraMat-Pro_1.jpg?v=1775058298","Jet Mat 72\" x 24\"":"https://cdn.shopify.com/s/files/1/0639/6172/7028/files/Amethyst-Tourmaline-Jade-Obsidian-Quartz-Jet-Mat_-Full-7224-Firm-Photon-PEMF-InfraMat-Pro_1.jpg?v=1775058298","Jet Mat Pro Plus 74\" x 28\"":"https://cdn.shopify.com/s/files/1/0639/6172/7028/files/Amethyst-Tourmaline-Jade-Obsidian-Quartz-Jet-Mat_-Full-Pro-7428-Firm-Photon-PEMF-InfraMat-Pro_1.png?v=1775058298"};
function sizeCode(){var d=(shopifySize||'').match(/\d+/g)||[];return d.slice(0,2).join('');}
function updateSizeImage(){var o=window.JET_SIZE_OVERRIDE||{};var u=o[sizeCode()]||SIZE_IMG[shopifySize];if(!u)return;var s0=document.querySelector('.slide[data-i="0"] img');if(s0){s0.src=u;s0.alt=sizeName+" Jet mat";}var t=document.querySelector(".thumb img");if(t)t.src=u;set(0);}

}
